import React from 'react'

import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { Icon } from '@fourthwall/components'

import * as S from './styled'
import type { Props, TypeButton } from './types'

export const PostTypeButtons = ({ buttons, activeButton, disabled, onClick }: Props) => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const handleClick = (button: TypeButton) => () => {
    if (!button.disabled && button.type !== activeButton) {
      onClick(button.type)
    }
  }

  const typeButtons = buttons.filter((button) => {
    if (button.type === 'LiveStream') return dashboardFeatureFlags.membershipsLiveStream.enabled

    return true
  })

  return (
    <S.Container>
      {typeButtons.map((button, index) => (
        <S.Button
          key={index}
          active={activeButton === button.type}
          disabled={button.disabled || disabled}
          onClick={handleClick(button)}
        >
          <Icon component={button.icon} height={16} />
          {button.label}
        </S.Button>
      ))}
    </S.Container>
  )
}
